import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { ModalController } from '@ionic/angular';
import { DiszpeldanyModalComponent } from './diszpeldany-modal.component';
import { TorzslapHataridoComponent } from './torzslap-hatarido.component';
import { PapirBizonyitvanyComponent } from './papir-bizonyitvany.component';
import { IntezmenytipusModalComponent } from './intezmenytipus-modal.component';
import { AgazatiAlapvizsgaModalComponent } from './agazati-alapvizsga-modal.component';
import { environment } from 'src/environments/environment';
import moment from 'moment';

@Component({
  selector: 'app-admin-dokumentumok',
  templateUrl: './dokumentumok.component.html',
  styleUrls: ['./dokumentumok.component.scss'],
})
export class AdminDokumentumokComponent implements OnInit {
  sajatIntezmeny: any;
  tanevLabel = '';
  exportFolyamatban = false;
  jogosult = false;

  // Töprengő / bizonyítvány-pótlap generálás
  osztalyok: any[] = [];
  kivosztaly: any = null;
  // Választható sablon: 'toprengo', 'bizonyitvany_potlap', 'bizonyitvany' vagy 'torzslap'.
  sablon: 'toprengo' | 'bizonyitvany_potlap' | 'bizonyitvany' | 'torzslap' = 'toprengo';
  toprengoDatum = '';
  zaroTipus: '2' | '3' = '2';
  datumElvalaszto: 'kotojel' | 'pont' = 'kotojel';
  csakElsoKeresztnev = false;
  // Bizonyítványnál: digitális aláírás + tárolás (a szülő letöltheti). Ha kikapcsolt,
  // a bizonyítvány is csak összefűzött PDF-ként töltődik le (nyomtatáshoz), mint a töprengő.
  bizonyitvanyAlairTarol = false;
  // Törzslapnál: tanulónként aláírva, KÖTELEZŐ időbélyeggel, a dokumentumtárba (és Iktatgatóval
  // iktatva) – backend/torzslap.js. Kikapcsolva: csak nyomtatható, összefűzött PDF.
  torzslapAlairTarol = true;
  aktTanevEv: string | null = null;
  toprengoFolyamatban = false;

  // Melyik nézet (kártya) látszik: 'export' | 'generalas' | 'lista'. A menügomb selectje állítja
  // (query paraméterrel), így egyszerre csak egy kártya van a lapon (nincs hosszú, dupla-scrollos oldal).
  nezet: 'export' | 'generalas' | 'lista' | 'archiv' = 'generalas';

  // Intézményvezető neve (bizonyítvány-sablon {{ intezmenyvezeto }}) – feladatellátási helyenként.
  intezmenyvezeto = '';
  intezmenyNev = '';
  intezmenyvezetoMentes = false;

  // Munkábajárás térítése (feladatellatas.benzinpenz, Ft/km): a Munkatársak › Riportok
  // „Utazás térítése” és a havi „MUNKÁBAJÁRÁS ELSZÁMOLÁSA” nyomtatvány díja.
  benzinpenz: number | null = null;
  benzinpenzMentes = false;

  // Generált dokumentumok admin lista + szűrő
  generaltDokumentumok: any[] = [];
  dokKereso = '';
  dokTipusSzuro = '';
  dokBetolt = false;
  private readonly dokTipusLabel: { [k: string]: string } = {
    bizonyitvany: 'Bizonyítvány',
    hatarozat: 'Határozat',
    kerveny: 'Kérvény',
    beadvany: 'Beadvány',
    toprengo: 'Töprengő',
    nyomtatvany: 'Kötelező nyomtatvány',
    potlap: 'Bizonyítvány-pótlap',
    torzslap: 'Törzslap',
    bizonyitvany_masodlat: 'Bizonyítványmásodlat',
  };

  // Bizonyítvány iktatószám-modal: tanulónként egy iktatószám, tanévenként megjegyezve.
  iktatoModalOpen = false;
  iktatoBetolt = false;
  iktatoTanev = '';
  iktatoNevsor: BizTetel[] = [];
  /** Az iktatószámot az Iktatgató adja (backend/bizonyitvany-iktatas.js) – kézzel nem kell megadni. */
  iktatoIktatgato = false;

  /*  A bizonyítvány tartalma (20/2012. EMMI r. 96. §, backend/bizonyitvany-tartalom.js): a modál a
   *  bizonyítványhoz és az aláírt pótlaphoz is ez. Keltezés (alapértéke a tanév utolsó tanítási napja,
   *  választható az évzáró osztályozó értekezlet napja), sorszám + pótlap-sorozat tanulónként, és a
   *  záradék nélküli tanulóknál a jegyekből számolt határozat-javaslat – csak jóváhagyva kerül rá. */
  bizModalMod: 'bizonyitvany' | 'potlap' = 'bizonyitvany';
  keltezes = '';
  keltezesek: Array<{ tipus: string; datum: string; cimke: string }> = [];
  tartalomHiba = '';
  sorszamMentes = false;
  /*  A nevelőtestületi határozat száma és kelte (96. § (3) j)) osztályra – a backend tanévenként
   *  megjegyzi (bizonyitvany_hatarozat); a kelte alapértéke az évzáró osztályozó értekezlet napja. */
  hatarozatSzam = '';
  hatarozatKelte = '';
  /** A bizonyítvány-sablonból hiányzó 96. §-os elemek (régi sablon) – csak figyelmeztetés. */
  sablonHianyok: Array<{ pont: string; nev: string }> = [];

  constructor(private data: DataService, private http: HttpClient, private route: ActivatedRoute, private modalCtrl: ModalController) {}

  /** Díszpéldány kiállítása / korábbiak (Nkt. 57. § (6b), backend/diszpeldany.js). */
  async diszpeldany(d: any) {
    const m = await this.modalCtrl.create({ component: DiszpeldanyModalComponent, componentProps: { dokumentumId: d.id } });
    await m.present();
  }

  /** Papír bizonyítvány jóváhagyott, előnyomott nyomtatványra + szigorú számadás (backend/papir-bizonyitvany.js). */
  async papirBizonyitvany() {
    const m = await this.modalCtrl.create({
      component: PapirBizonyitvanyComponent,
      cssClass: 'naplo-wide-modal',
      componentProps: {
        intezmeny: this.intezmenyPath(), tanevEv: this.aktTanevEv || '', osztalyok: this.osztalyok, kivosztaly: this.kivosztaly,
      },
    });
    await m.present();
  }

  /** Intézménytípus (iskolatípusok) és a díszpéldány díja – backend/bizonyitvany-tipus.js. */
  async intezmenytipus() {
    const m = await this.modalCtrl.create({ component: IntezmenytipusModalComponent, componentProps: { intezmeny: this.intezmenyPath() } });
    await m.present();
  }

  /** Ágazati alapvizsgák osztályonként (Szkt. 91. § (4)) – backend/agazati-alapvizsga.js. */
  async agazatiAlapvizsga() {
    const m = await this.modalCtrl.create({
      component: AgazatiAlapvizsgaModalComponent,
      componentProps: { intezmeny: this.intezmenyPath(), osztalyok: this.osztalyok, osztaly: this.kivosztaly ? String(this.kivosztaly) : null },
    });
    await m.present();
  }

  async ngOnInit() {
    // A menügomb selectje ?nezet=... paramétert állít; váltáskor betöltjük a listát, ha kell.
    this.route.queryParams.subscribe((p) => {
      const n = p['nezet'];
      if (n === 'export' || n === 'generalas' || n === 'lista' || n === 'archiv') this.nezet = n;
      if (this.nezet === 'lista') this.loadGeneraltDokumentumok();
    });
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    const jogkor = await this.data.getJogkor();
    // A hozzáférés a Jogosultságok szerkesztőből jön, nem az 'admin' jogkör nevéből –
    // így más jogkör is megkaphatja ezt a képernyőt (/admin/dokumentumok).
    this.jogosult = (await this.data.hozzaferesek()).szabad('/admin/dokumentumok');

    // A tanév kezdő évszáma (YYYY) az osztálylistához és a kerettanterv-sorrendhez.
    this.aktTanevEv = await this.deriveTanevEv();
    if (this.aktTanevEv) {
      const ev = Number(this.aktTanevEv);
      this.tanevLabel = `${ev} / ${ev + 1}`;
    }

    await this.loadOsztalyok();
    this.loadIntezmenyvezeto();
  }

  dokTipusNev(tipus: string): string {
    return this.dokTipusLabel[tipus] || (tipus || 'Dokumentum');
  }

  fileUrl(path: string): string {
    return this.backendApiUrl('/api/file/' + path);
  }

  loadGeneraltDokumentumok() {
    const intezmeny = this.intezmenyPath();
    if (!intezmeny) return;
    const params = new URLSearchParams();
    if (this.dokKereso.trim()) params.set('q', this.dokKereso.trim());
    if (this.dokTipusSzuro) params.set('tipus', this.dokTipusSzuro);
    const qs = params.toString() ? '?' + params.toString() : '';
    this.dokBetolt = true;
    this.http.get<any[]>(this.backendApiUrl('/api/dokumentumok/admin/' + intezmeny) + qs).subscribe({
      next: (lista) => {
        this.dokBetolt = false;
        this.generaltDokumentumok = Array.isArray(lista) ? lista : [];
      },
      error: (e) => {
        this.dokBetolt = false;
        console.error('Dokumentumlista hiba:', e);
        this.data.sendToast('Nem sikerült betölteni a dokumentumokat.', 'error');
      },
    });
  }

  loadIntezmenyvezeto() {
    const intezmenyId = this.intezmenyPath();
    if (!intezmenyId) return;
    this.data.getIntezmenyBeallitas(intezmenyId).subscribe({
      next: (r: any) => {
        this.intezmenyvezeto = r?.intezmenyvezeto || '';
        this.intezmenyNev = r?.name || '';
        this.benzinpenz = Number(r?.benzinpenz) || 0;
      },
      error: () => { /* marad üres */ },
    });
  }

  saveIntezmenyvezeto() {
    const intezmenyId = this.intezmenyPath();
    if (!intezmenyId) return;
    this.intezmenyvezetoMentes = true;
    this.data.setIntezmenyvezeto(intezmenyId, (this.intezmenyvezeto || '').trim()).subscribe({
      next: (r: any) => {
        this.intezmenyvezetoMentes = false;
        if (r?.ok) this.data.sendToast('Intézményvezető neve mentve.', 'success');
        else this.data.sendToast(r?.error || 'A mentés nem sikerült.', 'error');
      },
      error: (e) => {
        this.intezmenyvezetoMentes = false;
        this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
      },
    });
  }

  saveBenzinpenz() {
    const intezmenyId = this.intezmenyPath();
    if (!intezmenyId) return;
    const ft = Number(String(this.benzinpenz ?? '').replace(',', '.'));
    if (!Number.isFinite(ft) || ft < 0) {
      this.data.sendToast('A Ft/km díj nem érvényes szám.', 'error');
      return;
    }
    this.benzinpenzMentes = true;
    this.data.setMunkabajarasDij(intezmenyId, ft).subscribe({
      next: (r: any) => {
        this.benzinpenzMentes = false;
        if (r?.ok) {
          this.benzinpenz = r.benzinpenz;
          this.data.sendToast('A munkábajárás térítése mentve.', 'success');
        } else this.data.sendToast(r?.error || 'A mentés nem sikerült.', 'error');
      },
      error: (e) => {
        this.benzinpenzMentes = false;
        this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
      },
    });
  }

  private async deriveTanevEv(): Promise<string | null> {
    try {
      const akttev = JSON.parse(await this.data.getFromStorage('tanev')).aktualistanev;
      const tanevadatok = JSON.parse(await this.data.getFromStorage('tanevadatok'));
      const tanev = (Array.isArray(tanevadatok) ? tanevadatok : []).find((d: any) => d.id == akttev);
      if (tanev?.tankezd) return moment(tanev.tankezd).format('YYYY');
    } catch (e) {
      console.error('Tanév meghatározási hiba:', e);
    }
    return null;
  }

  private async loadOsztalyok() {
    const intezmenyId = this.intezmenyPath();
    if (!intezmenyId || !this.aktTanevEv) return;
    try {
      const lista = await this.data.getOsztaly(this.aktTanevEv, intezmenyId).toPromise();
      this.osztalyok = Array.isArray(lista) ? lista : [];
    } catch (e) {
      console.error('Osztálylista betöltési hiba:', e);
    }
  }

  // Tanulói törzsadat-export: üres osztály = teljes intézmény.
  tanuloExportOsztaly = '';
  tanuloExportGondviselo = true;
  tanuloExportFolyamatban = false;

  tanulokExport() {
    if (!this.jogosult) {
      this.data.sendToast('Ehhez az exporthoz admin jogosultság szükséges.', 'warning');
      return;
    }
    const intezmenyId = this.intezmenyPath();
    if (!intezmenyId) {
      this.data.sendToast('Nem található intézmény az exporthoz.', 'error');
      return;
    }

    const params = new URLSearchParams();
    if (this.tanuloExportOsztaly) params.set('osztaly', String(this.tanuloExportOsztaly));
    params.set('gondviselo', this.tanuloExportGondviselo ? '1' : '0');

    this.tanuloExportFolyamatban = true;
    this.data.showLoading('Tanulói adatok exportálása…');
    this.http
      .get(this.backendApiUrl('/api/admin/dokumentumok/tanulok/export/' + intezmenyId) + '?' + params.toString(),
        { responseType: 'blob' })
      .subscribe({
        next: (blob: Blob) => {
          this.tanuloExportFolyamatban = false;
          this.data.hideLoading();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          const osztalyNev = this.osztalyok.find((o) => o.id === this.tanuloExportOsztaly)?.osztaly;
          a.download = `tanuloi-adatok-${(osztalyNev || 'intezmeny').replace(/[^\w]+/g, '_')}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          this.data.sendToast('A tanulói adat-export elkészült.', 'success');
        },
        error: async (error) => {
          this.tanuloExportFolyamatban = false;
          this.data.hideLoading();
          console.error('Tanulói adat-export hiba:', error);
          let uzenet = 'Nem sikerült elkészíteni a tanulói adat-exportot.';
          if (error?.error instanceof Blob) {
            try {
              const parsed = JSON.parse(await error.error.text());
              if (parsed?.error) uzenet = parsed.error;
            } catch {}
          }
          this.data.sendToast(uzenet, 'error');
        },
      });
  }

  ertekelesekExport() {
    if (!this.jogosult) {
      this.data.sendToast('Ehhez az exporthoz admin jogosultság szükséges.', 'warning');
      return;
    }

    const intezmenyId = String(this.sajatIntezmeny?.intezmenyId || this.sajatIntezmeny?.id || '').trim();
    if (!intezmenyId) {
      this.data.sendToast('Nem található intézmény az exporthoz.', 'error');
      return;
    }

    const aktualisTanev = this.sajatIntezmeny?.aktualistanev;
    const query = aktualisTanev ? `?ev=${encodeURIComponent(String(aktualisTanev))}` : '';

    this.exportFolyamatban = true;
    this.data.megnyitFajl(`/api/admin/dokumentumok/ertekelesek/export/${intezmenyId}${query}`,
      'ertekelesek-export');
    setTimeout(() => {
      this.exportFolyamatban = false;
    }, 1500);
  }

  // A generálás gomb belépési pontja: bizonyítványnál bekapcsolt aláírás+tárolás
  // esetén a per-tanuló aláíró/tároló folyamat fut, egyébként sima PDF-letöltés.
  generate() {
    if (this.sablon === 'bizonyitvany' && this.bizonyitvanyAlairTarol) {
      this.generateBizonyitvany();
    } else if (this.sablon === 'bizonyitvany_potlap' && this.bizonyitvanyAlairTarol) {
      // Aláírt, tárolt pótlap: ugyanaz a modál (keltezés, sorszám, pótlap-sorozat, tanulók kijelölése).
      this.bizModalMod = 'potlap';
      this.openIktatoModal();
    } else if (this.sablon === 'torzslap' && this.torzslapAlairTarol) {
      this.generateTorzslapAlairt();
    } else {
      this.generateToprengo();
    }
  }

  generateToprengo() {
    if (!this.kivosztaly) {
      this.data.sendToast('Előbb válassz osztályt.', 'error');
      return;
    }

    const torzslap = this.sablon !== 'toprengo';
    const dokNev =
      this.sablon === 'bizonyitvany_potlap' ? 'Bizonyítvány pótlap'
      : this.sablon === 'bizonyitvany' ? 'Bizonyítvány'
      : this.sablon === 'torzslap' ? 'Törzslap'
      : 'Töprengő';
    const potlap = torzslap; // a törzslapos sablonoknál nincs félévi/évvégi a fájlnévben
    // A törzslapnak saját backend-útvonala van (teljes bizonyítvány-adat, aláírás/tárolás
    // nélkül); a többi sablon a közös /api/toprengo letöltő úton megy.
    const endpoint = this.sablon === 'torzslap' ? '/api/torzslap/' : '/api/toprengo/';
    const tipusNev = this.zaroTipus === '3' ? 'év végi' : 'félévi';
    const params = new URLSearchParams({
      osztaly: String(this.kivosztaly),
      sablon: this.sablon,
      zaroTipus: String(this.zaroTipus),
    });
    // A kerettanterv-sorrend tanévhez kötött; ha van aktuális tanév, küldjük.
    if (this.aktTanevEv) {
      params.set('ev', this.aktTanevEv);
    }
    // Opcionális dátum a dokumentumra; ha üres, a backend a mai dátumot használja.
    if (this.toprengoDatum) {
      params.set('datum', String(this.toprengoDatum).slice(0, 10));
    }
    // Dátum elválasztó a dokumentumon: kötőjeles (2026-06-09) vagy pontos (2026.06.09.).
    params.set('datumFormat', this.datumElvalaszto);
    // Ha be van kapcsolva, csak az első keresztnév jelenjen meg a dokumentumon.
    if (this.csakElsoKeresztnev) {
      params.set('csakElsoKeresztnev', '1');
    }

    this.toprengoFolyamatban = true;
    this.data.showLoading(potlap ? `${dokNev} generálása…` : `${dokNev} generálása (${tipusNev})…`);
    this.http
      .get(this.backendApiUrl(endpoint + this.intezmenyPath()) + '?' + params.toString(), {
        responseType: 'blob',
      })
      .subscribe({
        next: (blob: Blob) => {
          this.toprengoFolyamatban = false;
          this.data.hideLoading();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          const tipusReszNev = this.zaroTipus === '3' ? 'evvegi' : 'felevi';
          a.download =
            this.sablon === 'bizonyitvany_potlap' ? `bizonyitvany-potlap-${this.kivosztaly}.pdf`
            : this.sablon === 'bizonyitvany' ? `bizonyitvany-${this.kivosztaly}.pdf`
            : this.sablon === 'torzslap' ? `torzslap-${this.kivosztaly}.pdf`
            : `toprengo-${tipusReszNev}-${this.kivosztaly}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          this.data.sendToast(potlap ? `${dokNev} elkészült.` : `${dokNev} elkészült (${tipusNev}).`, 'success');
        },
        error: async (error) => {
          this.toprengoFolyamatban = false;
          this.data.hideLoading();
          console.error('Töprengő generálási hiba:', error);
          let uzenet = `Nem sikerült legenerálni: ${dokNev}.`;
          if (error?.error instanceof Blob) {
            try {
              const txt = await error.error.text();
              const parsed = JSON.parse(txt);
              if (parsed?.error) uzenet = parsed.error;
            } catch {}
          }
          this.data.sendToast(uzenet, 'error');
        },
      });
  }

  /** A határidő-kártya (újratöltés a generálás után). */
  @ViewChild(TorzslapHataridoComponent) torzslapHatarido?: TorzslapHataridoComponent;

  get intezmenyAzon(): string {
    return this.intezmenyPath();
  }

  // Törzslap: az osztály minden tanulójának törzslapja aláírva, időbélyeggel, a dokumentumtárba
  // (újragenerálásnál a régi érvénytelen; a 30 napos határidőhöz az első kiállítás számít).
  generateTorzslapAlairt() {
    if (!this.kivosztaly) {
      this.data.sendToast('Előbb válassz osztályt.', 'error');
      return;
    }
    if (!this.aktTanevEv) {
      this.data.sendToast('Nincs kiválasztott tanév.', 'error');
      return;
    }
    const params = new URLSearchParams({ osztaly: String(this.kivosztaly), ev: this.aktTanevEv, zaroTipus: String(this.zaroTipus) });
    if (this.toprengoDatum) params.set('datum', String(this.toprengoDatum).slice(0, 10));
    params.set('datumFormat', this.datumElvalaszto);
    if (this.csakElsoKeresztnev) params.set('csakElsoKeresztnev', '1');

    this.toprengoFolyamatban = true;
    this.data.showLoading('Törzslapok generálása, aláírása, időbélyegzése és tárolása…');
    this.http
      .post(this.backendApiUrl('/api/torzslap/' + this.intezmenyPath()) + '?' + params.toString(), {})
      .subscribe({
        next: (resp: any) => {
          this.toprengoFolyamatban = false;
          this.data.hideLoading();
          const n = resp?.generalt ?? 0;
          const hibaSzam = Array.isArray(resp?.hibak) ? resp.hibak.length : 0;
          if (hibaSzam) {
            const ok = String(resp.hibak[0]?.hiba || '').slice(0, 200);
            this.data.sendToast(`${n} törzslap aláírva és tárolva, ${hibaSzam} sikertelen${ok ? ` (${ok})` : ''}.`, 'warning');
          } else {
            this.data.sendToast(`${n} tanuló törzslapja aláírva, időbélyegezve és tárolva${resp?.iktatgato ? ', iktatva' : ''}.`, 'success');
          }
          this.torzslapHatarido?.betoltes();
        },
        error: (error) => {
          this.toprengoFolyamatban = false;
          this.data.hideLoading();
          console.error('Törzslap generálási hiba:', error);
          this.data.sendToast(error?.error?.error || 'Nem sikerült legenerálni a törzslapokat.', 'error');
        },
      });
  }

  // Bizonyítvány: előbb a tanulónkénti iktatószámokat kérjük be egy modálban (a tanévre
  // már mentett számokkal előtöltve), és csak megerősítés után indul a generálás.
  generateBizonyitvany() {
    this.bizModalMod = 'bizonyitvany';
    this.openIktatoModal();
  }

  // A modál megnyitása: betölti az osztály névsorát a backendről, az adott tanévre már
  // rögzített iktatószámokkal együtt (újrageneráláskor is ugyanaz jön vissza).
  async openIktatoModal() {
    if (!this.kivosztaly) {
      this.data.sendToast('Előbb válassz osztályt.', 'error');
      return;
    }
    this.iktatoBetolt = true;
    this.iktatoNevsor = [];
    this.keltezesek = [];
    this.tartalomHiba = '';
    this.hatarozatSzam = '';
    this.hatarozatKelte = '';
    this.sablonHianyok = [];
    this.iktatoModalOpen = true;
    const params = new URLSearchParams({ osztaly: String(this.kivosztaly) });
    if (this.aktTanevEv) params.set('ev', this.aktTanevEv);
    try {
      // Iktatószámok + a 96. §-os tartalom (sorszám, határozat-javaslat, keltezés) párhuzamosan.
      // A tartalom hibája nem állítja meg a generálást (a régi folyamat megy tovább).
      const [resp, tartalom]: any[] = await Promise.all([
        this.http
          .get(this.backendApiUrl('/api/bizonyitvany/iktato/' + this.intezmenyPath()) + '?' + params.toString())
          .toPromise(),
        this.http
          .get(this.backendApiUrl('/api/bizonyitvany-tartalom/nevsor/' + this.intezmenyPath()) + '?' + params.toString())
          .toPromise()
          .catch((e: any) => {
            console.error('Bizonyítvány-tartalom betöltési hiba:', e);
            this.tartalomHiba = e?.error?.error || 'A sorszámok és a határozat-javaslatok nem töltődtek be.';
            return null;
          }),
      ]);
      this.iktatoTanev = resp?.tanev || this.tanevLabel || '';
      this.iktatoIktatgato = !!resp?.iktatgato;
      this.keltezesek = Array.isArray(tartalom?.keltezesek) ? tartalom.keltezesek : [];
      this.hatarozatSzam = String(tartalom?.hatarozat?.szam || '');
      this.hatarozatKelte = String(tartalom?.hatarozat?.kelte || '').slice(0, 10);
      this.sablonHianyok = Array.isArray(tartalom?.sablonHianyok) ? tartalom.sablonHianyok : [];
      // A kártyán megadott dátum elsőbbséget kap; különben a tanév utolsó tanítási napja.
      this.keltezes = String(this.toprengoDatum || tartalom?.keltezes || '').slice(0, 10);
      const tartalomMap = new Map<string, any>(
        (Array.isArray(tartalom?.tetelek) ? tartalom.tetelek : []).map((t: any) => [String(t.oktazon), t] as [string, any]),
      );
      this.iktatoNevsor = (Array.isArray(resp?.tetelek) ? resp.tetelek : []).map((t: any) => {
        const x = tartalomMap.get(String(t.oktazon || '')) || {};
        const jav = x.javaslat || null;
        return {
          oktazon: String(t.oktazon || ''),
          nev: String(t.nev || ''),
          iktatoszam: String(t.iktatoszam || ''),
          sorszam: String(x.sorszam || ''),
          potlap_sorozat: String(x.potlap_sorozat || ''),
          sorszam_ev: String(x.sorszam_ev || ''),
          tantargySzam: Number(x.tantargySzam) || 0,
          javaslat: jav,
          hatarozatSzoveg: String(jav?.szoveg || ''),
          hatarozatJovahagyva: false,
          kijelolve: true,
        } as BizTetel;
      });
    } catch (error: any) {
      this.iktatoModalOpen = false;
      console.error('Iktatószám-névsor betöltési hiba:', error);
      this.data.sendToast(error?.error?.error || 'Nem sikerült betölteni a névsort.', 'error');
    } finally {
      this.iktatoBetolt = false;
    }
  }

  closeIktatoModal() {
    this.iktatoModalOpen = false;
  }

  // Van-e olyan tanuló, akinek nincs iktatószáma (a generálás gomb tiltásához). A pótlaphoz nem kell.
  get iktatoHianyzik(): boolean {
    if (this.iktatoIktatgato || this.bizModalMod === 'potlap') return false;
    return this.iktatoNevsor.some((t) => !String(t.iktatoszam || '').trim());
  }

  /** Van-e a tanulónak jóváhagyásra váró határozat-javaslata (nincs záradéka, de van javaslat). */
  vanJavaslat(t: BizTetel): boolean {
    return !!t.javaslat && t.javaslat.allapot !== 'zaradek' && t.javaslat.allapot !== 'nincs_adat';
  }

  /** Hány tanulónál nincs sem záradék, sem jóváhagyott határozat (96. § (3) j) – figyelmeztetés). */
  get hatarozatNelkul(): number {
    return this.iktatoNevsor.filter((t) => t.javaslat?.allapot !== 'zaradek'
      && !(t.hatarozatJovahagyva && String(t.hatarozatSzoveg || '').trim())).length;
  }

  /** Az összes javaslat jóváhagyása egyszerre (a szöveg előtte tanulónként átírható). */
  osszesJavaslatJovahagy() {
    for (const t of this.iktatoNevsor) {
      if (this.vanJavaslat(t) && String(t.hatarozatSzoveg || '').trim()) t.hatarozatJovahagyva = true;
    }
  }

  /** „az iskola címe ((2)), …” – a régi sablon hiányai a modálban. */
  get sablonHianySzoveg(): string {
    return this.sablonHianyok.map((h) => `${h.nev} (${h.pont})`).join(', ');
  }

  /** '2025' -> '2025/2026' */
  tanevFelirat(ev: string): string {
    return /^\d{4}$/.test(String(ev || '')) ? `${ev}/${Number(ev) + 1}` : String(ev || '');
  }

  get kijeloltSzam(): number {
    return this.iktatoNevsor.filter((t) => t.kijelolve).length;
  }

  private sorszamTetelek() {
    return this.iktatoNevsor.map((t) => ({
      oktazon: t.oktazon,
      sorszam: String(t.sorszam || '').trim(),
      potlap_sorozat: String(t.potlap_sorozat || '').trim(),
    }));
  }

  /** Sorszámok mentése generálás nélkül (tanévenként; a korábbi tanévről öröklött érték nem íródik újra). */
  sorszamokMentese() {
    if (!this.aktTanevEv) return;
    this.sorszamMentes = true;
    this.http
      .post(this.backendApiUrl('/api/bizonyitvany-tartalom/sorszam/' + this.intezmenyPath()),
        { ev: this.aktTanevEv, sorszamok: this.sorszamTetelek() })
      .subscribe({
        next: (r: any) => {
          this.sorszamMentes = false;
          this.data.sendToast(`Sorszámok mentve (${r?.mentve ?? 0} változás).`, 'success');
        },
        error: (e) => {
          this.sorszamMentes = false;
          this.data.sendToast(e?.error?.error || 'Nem sikerült menteni a sorszámokat.', 'error');
        },
      });
  }

  // Iktatószámok elküldése + generálás. A backend elmenti a számokat erre a tanévre
  // (megjegyzi), majd tanulónként aláírja és tárolja a bizonyítványt.
  confirmIktatoAndGenerate() {
    if (this.bizModalMod === 'potlap') {
      this.confirmPotlap();
      return;
    }
    if (this.iktatoHianyzik) {
      this.data.sendToast('Minden tanulóhoz adj meg iktatószámot.', 'error');
      return;
    }
    const iktatoszamok = this.iktatoNevsor.map((t) => ({
      oktazon: t.oktazon,
      iktatoszam: String(t.iktatoszam || '').trim(),
    }));
    const params = new URLSearchParams({ osztaly: String(this.kivosztaly) });
    if (this.aktTanevEv) params.set('ev', this.aktTanevEv);
    if (this.csakElsoKeresztnev) params.set('csakElsoKeresztnev', '1');

    // Csak a jóváhagyott határozat-javaslatok mennek: a backend záradékként is rögzíti őket.
    const hatarozatok = this.iktatoNevsor
      .filter((t) => this.vanJavaslat(t) && t.hatarozatJovahagyva && String(t.hatarozatSzoveg || '').trim())
      .map((t) => ({ oktazon: t.oktazon, szoveg: String(t.hatarozatSzoveg).trim() }));
    const torzs: any = {
      iktatoszamok, sorszamok: this.sorszamTetelek(), hatarozatok,
      hatarozatSzam: String(this.hatarozatSzam || '').trim(),
      hatarozatKelte: String(this.hatarozatKelte || '').slice(0, 10),
    };
    if (this.keltezes) torzs.keltezes = String(this.keltezes).slice(0, 10);

    this.toprengoFolyamatban = true;
    this.data.showLoading('Bizonyítványok generálása, aláírása és tárolása…');
    this.http
      .post(this.backendApiUrl('/api/bizonyitvany/' + this.intezmenyPath()) + '?' + params.toString(), torzs)
      .subscribe({
        next: (resp: any) => {
          this.toprengoFolyamatban = false;
          this.data.hideLoading();
          this.iktatoModalOpen = false;
          const n = resp?.generalt ?? 0;
          const hibaSzam = Array.isArray(resp?.hibak) ? resp.hibak.length : 0;
          //  Figyelmeztetés (nem hiba): pl. nincs kijelölt igazgatói aláíró tanúsítvány (Nkt. 57. § (6a)),
          //  vagy az LTV-adatok nem kerültek be teljesen.
          const figy = Array.isArray(resp?.figyelmeztetes) && resp.figyelmeztetes.length ? ` Figyelem: ${resp.figyelmeztetes.join(' ')}` : '';
          if (hibaSzam) {
            const ok = String(resp.hibak[0]?.hiba || '').slice(0, 200);
            this.data.sendToast(`${n} bizonyítvány aláírva és tárolva, ${hibaSzam} sikertelen${ok ? ` (${ok})` : ''}.${figy}`, 'warning');
          } else {
            this.data.sendToast(`${n} tanuló bizonyítványa aláírva és tárolva.${figy}`, figy ? 'warning' : 'success');
          }
        },
        error: (error) => {
          this.toprengoFolyamatban = false;
          this.data.hideLoading();
          console.error('Bizonyítvány generálási hiba:', error);
          // A backend a hiányzó iktatószámokat külön listában adja vissza.
          if (Array.isArray(error?.error?.hianyzoIktato) && error.error.hianyzoIktato.length) {
            const nevek = error.error.hianyzoIktato.map((h: any) => h.nev).join(', ');
            this.data.sendToast(`Hiányzó iktatószám: ${nevek}`, 'error');
          } else {
            this.data.sendToast(error?.error?.error || 'Nem sikerült legenerálni a bizonyítványokat.', 'error');
          }
        },
      });
  }

  /** Aláírt, tárolt pótlap a kijelölt tanulóknak (backend/bizonyitvany-tartalom.js, tipus = 'potlap'). */
  confirmPotlap() {
    const oktazonok = this.iktatoNevsor.filter((t) => t.kijelolve).map((t) => t.oktazon);
    if (!oktazonok.length) {
      this.data.sendToast('Jelölj ki legalább egy tanulót.', 'error');
      return;
    }
    const params = new URLSearchParams({ osztaly: String(this.kivosztaly) });
    if (this.aktTanevEv) params.set('ev', this.aktTanevEv);
    if (this.csakElsoKeresztnev) params.set('csakElsoKeresztnev', '1');
    const torzs: any = { sorszamok: this.sorszamTetelek(), oktazonok };
    if (this.keltezes) torzs.keltezes = String(this.keltezes).slice(0, 10);

    this.toprengoFolyamatban = true;
    this.data.showLoading('Pótlapok generálása, aláírása és tárolása…');
    this.http
      .post(this.backendApiUrl('/api/bizonyitvany-tartalom/potlap/' + this.intezmenyPath()) + '?' + params.toString(), torzs)
      .subscribe({
        next: (resp: any) => {
          this.toprengoFolyamatban = false;
          this.data.hideLoading();
          this.iktatoModalOpen = false;
          const n = resp?.generalt ?? 0;
          const hibaSzam = Array.isArray(resp?.hibak) ? resp.hibak.length : 0;
          if (hibaSzam) {
            const ok = String(resp.hibak[0]?.hiba || '').slice(0, 200);
            this.data.sendToast(`${n} pótlap aláírva és tárolva, ${hibaSzam} sikertelen${ok ? ` (${ok})` : ''}.`, 'warning');
          } else {
            this.data.sendToast(`${n} tanuló pótlapja aláírva és tárolva.`, 'success');
          }
        },
        error: (error) => {
          this.toprengoFolyamatban = false;
          this.data.hideLoading();
          console.error('Pótlap generálási hiba:', error);
          this.data.sendToast(error?.error?.error || 'Nem sikerült legenerálni a pótlapokat.', 'error');
        },
      });
  }

  private backendApiUrl(path: string): string {
    const apiOrigin = (environment.apiOrigin || '').replace(/\/api\/?$/, '').replace(/\/$/, '');
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return apiOrigin ? `${apiOrigin}${normalizedPath}` : normalizedPath;
  }

  private intezmenyPath(): string {
    return String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
  }
}

/** A bizonyítvány-modál egy sora (iktatószám + a 96. §-os tartalom). */
interface BizTetel {
  oktazon: string;
  nev: string;
  iktatoszam: string;
  sorszam: string;
  potlap_sorozat: string;
  /** Melyik tanévtől öröklött a sorszám (ha korábbi, mint a mostani). */
  sorszam_ev: string;
  tantargySzam: number;
  javaslat: {
    allapot: 'zaradek' | 'tovabb' | 'javitovizsga' | 'ismetles' | 'osztalyozo' | 'nincs_adat';
    szoveg: string;
    zaradek?: string[];
    alternativak: string[];
    indoklas: string;
    figyelmeztetesek: string[];
  } | null;
  hatarozatSzoveg: string;
  hatarozatJovahagyva: boolean;
  /** Pótlapnál: kap-e pótlapot. */
  kijelolve: boolean;
}
